import { BASE_FONT_SIZE, SCALING_LIMIT, SCALING_OPTIONS } from '../constants';

export const getAutoScalingFontSize = (): number => {
	if (
		window.screen.width <= SCALING_LIMIT.WIDTH &&
		window.screen.height <= SCALING_LIMIT.HEIGHT &&
		window.devicePixelRatio >= SCALING_LIMIT.DPR
	) {
		const baseFontIndex = SCALING_OPTIONS.findIndex((option) => option.value === BASE_FONT_SIZE);
		if (baseFontIndex > 0) {
			const previousScalingOption = SCALING_OPTIONS[baseFontIndex - 1];
			if (previousScalingOption) {
				return previousScalingOption.value;
			}
		}
	}
	return BASE_FONT_SIZE;
};
